import React, {useMemo} from "react";
import "./index.scss";
import OnboardingStages from "features/pages/account/onboarding/stages";
import Title from "features/components/title";
import {__} from "services/i18n";
import {connect} from "react-redux";
import {myCompaniesSelector} from "store/reducer/company/selectors";
import {profileData} from "store/reducer/user/profile/selectors";
import CompanyInfo from "features/components/company-info";
import {getCompaniesStart} from "store/reducer/company/reducer";
import Text from "features/components/text";
import {getProfileStart} from "store/reducer/user/profile/reducer";
import {onboardingCompleteErrorSelector} from "features/pages/account/onboarding/selectors";
import {generateFullUrl} from "services/utils/utils";

/* istanbul ignore next */
const mapStateToProps = state => ({
    companies: myCompaniesSelector(state),
    profile: profileData(state),
    error: onboardingCompleteErrorSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    getCompaniesStart,
    getProfileStart
};


export const OnboardingRecap = (props) => {
    const {companies, getCompaniesStart, profile, getProfileStart, error} = props;

    React.useEffect(() => {
        getCompaniesStart();
        getProfileStart();
    }, [getCompaniesStart, getProfileStart]);

    const profileImage = useMemo(() => {
        if(!profile.image) {
            return null;
        }
        return profile.image.src || generateFullUrl(profile.image);
    }, [profile]);

    return <div className={"white-box onboarding-recap"}>
        <OnboardingStages index={2} />
        <Title size={24} align={"center"}>{__("onboarding.recap.title")}</Title>
        <Title size={18}>{__("onboarding.recap.on-you")}</Title>
        {
            !!profile.firstName && <div className="company-info">
                <div className="content">
                    <div className="image">
                        {!!profileImage && <img src={profileImage} alt={"profile"}/>}
                    </div>
                    <div className="name-role">
                        <Title size={20}>{profile.firstName} {profile.lastName}</Title>
                        <Text size={16}>{profile.office} | {profile.phone} | {profile.email}</Text>
                    </div>
                </div>
            </div>
        }
        <Title size={18}>{companies.length} {__(`common.associated-companies-${companies.length === 1 ? "single" : "plural"}`)}</Title>
        {
            companies.map(item => <CompanyInfo
                key={item.id}
                showValid={false}
                company={item} />)
        }
        {error.inError && <Text size={16} color={"danger"}>{__(error.error)}</Text>}
    </div>
};


export default connect(mapStateToProps, mapDispatchToProps)(OnboardingRecap);